import React, { useState } from "react";
import { IoClose } from "react-icons/io5";

/**
 * Component for displaying an uploaded picture with a comment box and a close button.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.picture - The picture object containing the file and comment.
 * @param {Function} props.onCommentChange - The function to call when the comment changes.
 * @param {Function} props.onClose - The function to call when the close button is clicked.
 */
const UploadedPicture = ({
  picture,
  onCommentChange,
  onCaptionChange,
  onCaptionToggle,
  onClose,
}) => {
  const [isCaptionEnabled, setIsCaptionEnabled] = useState(true);

  const handleCommentChange = (e) => {
    onCommentChange(e.target.value);
  };

  const handleCaptionChange = (e) => {
    onCaptionChange(e.target.value);
  };

  const handleCaptionToggle = () => {
    setIsCaptionEnabled(!isCaptionEnabled);
    onCaptionToggle();
  };

  return (
    <div className="mb-4 flex flex-col text-gray-700 py-2 p-1 shadow-gray-300 rounded-lg shadow-md relative">
      <button
        onClick={onClose}
        className="absolute bg-gray-400 hover:scale-125 shadow-md shadow-gray-700 opacity-75 rounded-3xl top-2 right-2 p-2 transition-colors ease-in-out duration-200"
      >
        <IoClose className="text-xl text-black" />
      </button>
      <img
        src={URL.createObjectURL(picture.file)}
        alt="Uploaded"
        className="w-full col-span-2 md:col-span-1 object-cover rounded-t-md mr-4"
      />
      <div className="mt-auto">
        <div className="flex items-center">
          <input
            type="checkbox"
            checked={isCaptionEnabled}
            onChange={handleCaptionToggle}
            className="mr-2 mt-2"
          />
          <label
            className="block text-gray-700 text-sm font-bold mt-2"
            htmlFor="caption"
          >
            Caption (added to photo on upload):
          </label>
        </div>
        <textarea
          value={picture.caption}
          onChange={handleCaptionChange}
          placeholder="Add comments..."
          rows={picture.caption.split(/\r\n|\r|\n/).length + 1} // Set the rows to the number of lines in the caption
          className={`resize-y mt-auto shadow col-span-2 md:col-span-3 appearance-none caret-black border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline ${!isCaptionEnabled ? "bg-gray-200 text-gray-300" : "text-gray-700"}`}
          disabled={!isCaptionEnabled}
        />
        <label
          className="block text-gray-700 text-sm font-bold mb-2"
          htmlFor="comment"
        >
          Comments:
        </label>
        <textarea
          value={picture.comment}
          onChange={handleCommentChange}
          placeholder="Add comments..."
          className="mt-auto shadow col-span-2 md:col-span-3 appearance-none caret-black border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        />
      </div>
    </div>
  );
};

export default UploadedPicture;
